export const normalizePlateSearch = value => String(value || '')
  .trim()
  .replace(/[^A-Za-z0-9]/g, '')
  .toUpperCase();
